import React from "react";
import { useTranslation } from "react-i18next";
import { Table as AntTable } from "antd";

export interface IEmployeeSummaryTotals {
  basic?: number;
  standard?: number;
  certification?: number;
}

interface IEmployeeSummaryProps {
  totals: IEmployeeSummaryTotals | null | undefined;
}

const FOOTER_VALUES: (keyof IEmployeeSummaryTotals)[] = [
  "basic",
  "standard",
  "certification",
];

export const EmployeeSummary = ({ totals }: IEmployeeSummaryProps) => {
  const { t } = useTranslation();

  if (!totals) return null;

  return (
    <AntTable.Summary fixed>
      <AntTable.Summary.Row>
        <AntTable.Summary.Cell index={0} colSpan={5}>
          {t("employeeTraining.total")}
        </AntTable.Summary.Cell>
        {FOOTER_VALUES.map((key, i) => (
          <AntTable.Summary.Cell key={key} index={4 + i}>
            {totals[key] ?? ""}
          </AntTable.Summary.Cell>
        ))}
        <AntTable.Summary.Cell index={7}>{""}</AntTable.Summary.Cell>
      </AntTable.Summary.Row>
    </AntTable.Summary>
  );
};
